"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var filesize_1 = require("filesize");
exports.head = document.getElementsByTagName('head')[0];
exports.IE = isIE();
exports.loadedScripts = {};
function getType(p) {
    if (Array.isArray(p))
        return 'array';
    else if (typeof p == 'string')
        return 'string';
    else if (p != null && typeof p == 'object')
        return 'object';
    else
        return 'other';
}
exports.getType = getType;
function isEmpty(obj) {
    for (var x in obj)
        return false;
    return true;
}
exports.isEmpty = isEmpty;
function getCookie(sKey) {
    if (!sKey) {
        return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}
exports.getCookie = getCookie;
function isIE() {
    var myNav = navigator.userAgent.toLowerCase();
    if (myNav.indexOf('msie') != -1)
        return parseInt(myNav.split('msie')[1]);
    var appVersion = navigator.appVersion ? navigator.appVersion.toLowerCase() : '';
    if (appVersion.indexOf('trident/') != -1)
        return true;
    return false;
}
exports.isIE = isIE;
function appendScript(url) {
    if (url in exports.loadedScripts) {
        return exports.loadedScripts[url];
    }
    else {
        return exports.loadedScripts[url] = new Promise(function (resolve, reject) {
            var r = false, t = document.getElementsByTagName("script")[0], s = document.createElement("script");
            s.type = "text/javascript";
            s.src = url;
            if (exports.IE == 9) {
                s['onreadystatechange'] = function () {
                    if (this.readyState == 'complete' || this.readyState == 'loaded') {
                        r = true;
                        resolve(url);
                    }
                };
            }
            else {
                s.async = true;
                s.onload = s['onreadystatechange'] = function () {
                    if (!r && (!this.readyState || this.readyState == "complete")) {
                        r = true;
                        resolve(url);
                    }
                };
            }
            s.onerror = s.onabort = reject;
            t.parentNode.insertBefore(s, t);
        });
    }
}
exports.appendScript = appendScript;
function appendCSS(name, url, isAtTop) {
    return new Promise(function (resolve, reject) {
        var link = document.createElement('link');
        link.id = name + '_css';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        link.onload = function () {
            handle404Error(link, false);
        };
        link.onerror = function () {
            handle404Error(link, true);
        };
        function handle404Error(el, failed) {
            if (failed) {
                reject('Error: ' + name + ' stylesheet was not loaded.');
            }
            else {
                resolve();
            }
        }
        if (isAtTop) {
            var head_1 = document.getElementsByTagName("head")[0];
            head_1.insertBefore(link, head_1.children[0]);
        }
        else {
            exports.head.appendChild(link);
        }
    });
}
exports.appendCSS = appendCSS;
function prependCSS(name, url, node) {
    return new Promise(function (resolve, reject) {
        var link = document.createElement('link');
        link.id = name + '_css';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        link.onload = function () {
            handle404Error(link, false);
        };
        link.onerror = function () {
            handle404Error(link, true);
        };
        function handle404Error(el, failed) {
            if (failed) {
                reject('Error: ' + name + ' stylesheet was not loaded.');
            }
            else {
                resolve();
            }
        }
        var head = document.getElementsByTagName("head")[0];
        head.insertBefore(link, node);
    });
}
exports.prependCSS = prependCSS;
function convertBytesToFileSize(bytes) {
    return filesize_1.default(bytes);
}
exports.convertBytesToFileSize = convertBytesToFileSize;
function triggerEvent(event) {
    var evt = document.createEvent("Event");
    evt.initEvent(event, true, false);
    window.dispatchEvent(evt);
}
exports.triggerEvent = triggerEvent;
var InitializationContext = (function () {
    function InitializationContext() {
    }
    return InitializationContext;
}());
exports.InitializationContext = InitializationContext;
;
var LoggingInitializationContext = (function () {
    function LoggingInitializationContext() {
    }
    return LoggingInitializationContext;
}());
exports.LoggingInitializationContext = LoggingInitializationContext;
var LoggingInitializationServiceContext = (function () {
    function LoggingInitializationServiceContext() {
    }
    return LoggingInitializationServiceContext;
}());
exports.LoggingInitializationServiceContext = LoggingInitializationServiceContext;
var LoggingInitializationPageContext = (function () {
    function LoggingInitializationPageContext() {
    }
    return LoggingInitializationPageContext;
}());
exports.LoggingInitializationPageContext = LoggingInitializationPageContext;
var ServiceEndpoint = (function () {
    function ServiceEndpoint() {
    }
    return ServiceEndpoint;
}());
exports.ServiceEndpoint = ServiceEndpoint;
var EndpointInitializationContext = (function (_super) {
    __extends(EndpointInitializationContext, _super);
    function EndpointInitializationContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EndpointInitializationContext;
}(ServiceEndpoint));
exports.EndpointInitializationContext = EndpointInitializationContext;



//////////////////
// WEBPACK FOOTER
// ./src/Utilities/index.ts
// module id = 1
// module chunks = 0